export default __webpack_public_path__ + "static/media/avvenire.0b2af737.jpeg";